export default {"src":"/_next/static/media/transit-parking.0ecc16a9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};